import api from './api';

export async function listCategories(params = {}) {
  const query = new URLSearchParams();
  if (params.type) query.append('type', params.type);
  if (params.accountId) query.append('accountId', params.accountId);
  const res = await api.get(`/categories${query.toString() ? `?${query.toString()}` : ''}`);
  return res.data?.data || [];
}

export async function createCategory({ name, type, accountId, color }) {
  const res = await api.post('/categories', { name, type, accountId, color });
  return res.data?.data;
}

export async function reorderCategories({ accountId, type, orderedIds }) {
  const res = await api.put('/categories/reorder', { accountId, type, orderedIds });
  return res.data?.data || [];
}

export async function updateCategory(id, { name, color }) {
  const res = await api.put(`/categories/${id}`, { name, color });
  return res.data?.data;
}

export async function deleteCategory(id) {
  const res = await api.delete(`/categories/${id}`);
  return res.data;
}
